import pako from "pako";

export const getCanvasPointFromMouseClick = (
  event: React.MouseEvent | React.TouchEvent,
  canvasRef: React.RefObject<HTMLCanvasElement>,
  zoomScale: number,
) => {
  if (canvasRef.current == null) {
    return;
  }

  const canvas = canvasRef.current;

  const canvasRect = canvas.getBoundingClientRect();

  let cursorPoint = { x: 0, y: 0 };

  if (event.nativeEvent instanceof MouseEvent) {
    cursorPoint.x = event.nativeEvent.clientX - canvasRect.left;
    cursorPoint.y = event.nativeEvent.clientY - canvasRect.top;
  } else if (event.nativeEvent instanceof TouchEvent) {
    cursorPoint.x = event.nativeEvent.changedTouches[0].clientX - canvasRect.left;
    cursorPoint.y = event.nativeEvent.changedTouches[0].clientY - canvasRect.top;
  }

  // Adjust coordinates for zoom
  cursorPoint.x /= zoomScale;
  cursorPoint.y /= zoomScale;

  return cursorPoint;
};

const clampToNearest = (arr: Uint8ClampedArray): Uint8ClampedArray => {
  const validValues = [0, 205, 254];

  const nearest = (value: number) => {
    let closest = validValues[0];
    let minDiff = Math.abs(value - closest);

    for (let i = 1; i < validValues.length; i++) {
      const diff = Math.abs(value - validValues[i]);
      if (diff < minDiff) {
        minDiff = diff;
        closest = validValues[i];
      }
    }

    return closest;
  };

  for (let i = 0; i < arr.length; i++) {
    if (!validValues.includes(arr[i])) {
      arr[i] = nearest(arr[i]);
    }
  }

  return arr;
};

const uint8ArrayToBase64 = (uint8Array: Uint8Array): string => {
  let binaryString = "";
  const chunkSize = 8192;
  for (let i = 0; i < uint8Array.length; i += chunkSize) {
    const chunk = uint8Array.subarray(i, i + chunkSize);
    binaryString += String.fromCharCode.apply(null, chunk as any);
  }
  return window.btoa(binaryString);
};

export const convertUint8ArrayToString = (uint8Array: Uint8ClampedArray): string => {
  const clampedData = clampToNearest(uint8Array);
  const compressedData = pako.gzip(new Uint8Array(clampedData));
  const base64String = uint8ArrayToBase64(compressedData);

  return base64String;
};
